import { render, staticRenderFns } from "./article-detail.vue?vue&type=template&id=37cefa1c&scoped=true&"
import script from "./article-detail.vue?vue&type=script&lang=js&"
export * from "./article-detail.vue?vue&type=script&lang=js&"
import style0 from "./article-detail.vue?vue&type=style&index=0&id=37cefa1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cefa1c",
  null
  
)

export default component.exports